var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import RadioButton from "@frameworks/web/components/generic/radioButton";
import DeskPeriod from "./DeskPeriod";
import UploadAttendance from "./UploadAttendance";
import EdButton from "../../../../web/components/generic/edbutton/edButton";
import profileDI from "@frameworks/salesjourney/components/Features/Profile/di/serviceLocator";
import Loader from "@frameworks/shared-library/components/Loader";
import moment from "moment";
import { base64toExcel } from "@frameworks/salesjourney/utils/genericMethods";
import { getDateInFormat, getLocalISOString } from "@domains/utils/reportDates";
import { deskPeriodMsg } from "../constant";
var SetOffDesk = function (props) {
    var _a;
    var _b = __read(useState(undefined), 2), fromDate = _b[0], setFromDate = _b[1];
    var _c = __read(useState(undefined), 2), toDate = _c[0], setToDate = _c[1];
    var _d = __read(useState("1"), 2), selectedDeskTab = _d[0], setSelectedDeskTab = _d[1];
    var _e = __read(useState(true), 2), showDeskPeriodMsg = _e[0], setShowDeskPeriodMsg = _e[1];
    var _f = __read(useState(false), 2), isShowLoader = _f[0], setIsShowLoader = _f[1];
    var _g = __read(useState({}), 2), uploadedFile = _g[0], setUploadedFile = _g[1];
    var _h = __read(useState(false), 2), isDeskOffTimeExceeded = _h[0], setIsDeskOffTimeExceeded = _h[1];
    var _j = __read(useState(false), 2), isSuccessful = _j[0], setIsSuccessful = _j[1];
    var _k = __read(useState({
        fileError: false,
        uploadError: false,
        deskSetError: false,
        base64File: "",
    }), 2), isError = _k[0], setIsError = _k[1];
    var _l = __read(useState([
        {
            value: "1",
            display: "Set Off Desk Period",
        },
        {
            value: "2",
            display: "Upload Attendance CSV",
        },
    ]), 2), deskPeriodTab = _l[0], setDeskPeriodTab = _l[1];
    var generateErrorMsg = function (errorState) {
        return (React.createElement("div", { className: "d-flex flex-column align-items-center m-5" },
            React.createElement("div", null,
                React.createElement("i", { className: "edel-icon-file-decline" },
                    React.createElement("span", { className: "path1" }),
                    React.createElement("span", { className: "path2" }),
                    React.createElement("span", { className: "path3" }))),
            React.createElement("div", { className: "d-flex flex-column align-items-center" }, selectedDeskTab == "1" && (errorState === null || errorState === void 0 ? void 0 : errorState.deskSetError) ? (React.createElement("div", { className: "DMSanBold_18_700 txt-midnight-blue my-2" }, "Off Desk Period couldn\u2019t be set")) : (errorState === null || errorState === void 0 ? void 0 : errorState.fileError) ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "DMSanBold_18_700 txt-midnight-blue my-2" }, "File error"),
                React.createElement("div", { className: "DMSansNormal_12_400 success-desk-period mb-1" }, "We couldn\u2019t upload your CSV file, due to erreneous records. Please download the file to view errors."),
                React.createElement("div", { className: "DMSansMedium_15_500 txt-midnight-blue mt-3 try-block" },
                    React.createElement("span", { className: "d-flex hand_cursor", onClick: function () {
                            base64toExcel(errorState === null || errorState === void 0 ? void 0 : errorState.base64File, getDateInFormat(new Date(), "DD_MM_YYYY") + ".csv");
                        } },
                        React.createElement("i", { className: "edel-icon-bold-download me-2" }),
                        React.createElement("span", { className: "text-decoration-underline " }, "Download Error Log"))))) : (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "DMSanBold_18_700 txt-midnight-blue my-2" }, "Couldn\u2019t upload file"),
                React.createElement("div", { className: "DMSansNormal_12_400 success-desk-period mb-1" }, "We couldn\u2019t upload your CSV file, please try again"),
                React.createElement("div", { className: "DMSansMedium_15_500 txt-midnight-blue mt-3 try-block" },
                    React.createElement("span", { className: "d-flex hand_cursor", onClick: function () {
                            setSelectedDeskTab("2");
                            setIsError({
                                fileError: false,
                                uploadError: false,
                                deskSetError: false,
                                base64File: "",
                            });
                        } },
                        React.createElement("i", { className: "edel-icon-refresh me-2" }),
                        React.createElement("span", { className: "text-decoration-underline " }, "Try Again"))))))));
    };
    var generateSuccessMsg = function () {
        return (React.createElement("div", { className: "d-flex flex-column align-items-center mx-5 mb-4 mt-5 text-nowrap" },
            React.createElement("span", { className: "mb-3 successful-desk-icon d-flex align-items-center justify-content-center " },
                React.createElement("span", { className: "circled-backg d-flex align-items-center justify-content-center" },
                    React.createElement("i", { className: "edel-icon-successful" }))),
            selectedDeskTab == "1" ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "DMSanBold_18_700 txt-midnight-blue mb-2" }, "Off Desk Period has been set Successfuly!"),
                React.createElement("div", { className: "DMSansNormal_12_400 success-desk-period mt-2" },
                    "Your Off Desk Period has been set from",
                    " ",
                    React.createElement("span", { className: "DMSanB_12_700" }, moment(fromDate).format("DD-MM-YYYY")),
                    " ",
                    "to",
                    " ",
                    React.createElement("span", { className: "DMSanB_12_700" }, moment(toDate).format("DD-MM-YYYY"))))) : (React.createElement("div", { className: "DMSanBold_18_700 txt-midnight-blue mb-2" }, "Attendance CSV was upload Successfuly!"))));
    };
    var getMarkAbsentee = function () {
        setIsShowLoader(true);
        profileDI.profile
            .getMarkAbsentee({
            fromDate: getLocalISOString(fromDate),
            toDate: getLocalISOString(toDate),
        })
            .then(function (resp) {
            if (resp === null || resp === void 0 ? void 0 : resp.isSuccess) {
                setIsShowLoader(false);
                setIsSuccessful(true);
            }
            else {
                setIsError({
                    fileError: false,
                    uploadError: false,
                    deskSetError: true,
                    base64File: "",
                });
                setIsShowLoader(false);
            }
        })
            .catch(function () {
            setIsError({
                fileError: false,
                uploadError: false,
                deskSetError: true,
                base64File: "",
            });
            setIsShowLoader(false);
        });
    };
    var getDocumentUpload = function (filename, file) {
        setIsShowLoader(true);
        profileDI.profile
            .getDocumentUpload({ fileName: filename, fileBase64String: file })
            .then(function (resp) {
            var _a, _b, _c, _d, _e;
            if ((resp === null || resp === void 0 ? void 0 : resp.success) && ((_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.isSuccess)) {
                base64toExcel((_b = resp === null || resp === void 0 ? void 0 : resp.data) === null || _b === void 0 ? void 0 : _b.fileBase64String, getDateInFormat(new Date(), "DD_MM_YYYY") + ".csv");
                setIsSuccessful(true);
            }
            else if ((resp === null || resp === void 0 ? void 0 : resp.success) && ((_c = resp === null || resp === void 0 ? void 0 : resp.data) === null || _c === void 0 ? void 0 : _c.isSuccess) == false) {
                setIsError({
                    fileError: true,
                    uploadError: false,
                    deskSetError: false,
                    base64File: ((_d = resp === null || resp === void 0 ? void 0 : resp.data) === null || _d === void 0 ? void 0 : _d.fileBase64String)
                        ? (_e = resp === null || resp === void 0 ? void 0 : resp.data) === null || _e === void 0 ? void 0 : _e.fileBase64String
                        : "",
                });
            }
            else {
                setIsError({
                    fileError: false,
                    uploadError: true,
                    deskSetError: false,
                    base64File: "",
                });
            }
        })
            .catch(function () {
            setIsError({
                fileError: false,
                uploadError: true,
                deskSetError: false,
                base64File: "",
            });
        });
        setIsShowLoader(false);
    };
    var handleSubmit = function () {
        if (selectedDeskTab == "2") {
            var base64DataSplit = uploadedFile.base64Data.split(",");
            getDocumentUpload(uploadedFile.docFile, base64DataSplit[1]);
        }
        else if (selectedDeskTab == "1") {
            getMarkAbsentee();
        }
    };
    useEffect(function () {
        var currentTime = new Date().toLocaleTimeString();
        var setOffTime = new Date();
        setOffTime.setHours(10);
        setOffTime.setMinutes(30);
        setOffTime.setSeconds(0);
        if (currentTime > setOffTime.toLocaleTimeString()) {
            setIsDeskOffTimeExceeded(true);
        }
        else {
            setIsDeskOffTimeExceeded(false);
        }
    }, []);
    return isSuccessful ? (React.createElement(React.Fragment, null, generateSuccessMsg())) : isError.fileError || isError.uploadError || isError.deskSetError ? (React.createElement(React.Fragment, null, generateErrorMsg(isError))) : isShowLoader ? (React.createElement("div", { className: "loaderClass" },
        React.createElement(Loader, null))) : (React.createElement("div", { className: "desk-period-child" },
        showDeskPeriodMsg ? (React.createElement("div", { className: "d-flex align-items-center bg_aqua_white desk-period-child-head" },
            React.createElement("div", { className: "info-icon d-flex align-items-center justify-content-center" },
                React.createElement("i", { className: "edel-icon-info1" })),
            React.createElement("span", { className: "DMSansNormal_12_400 txt-midnight-blue" }, deskPeriodMsg))) : (React.createElement("div", { className: "pb-4" })),
        React.createElement("div", { className: "d-flex desk-radio-button" }, deskPeriodTab === null || deskPeriodTab === void 0 ? void 0 : deskPeriodTab.map(function (radio, idx) {
            return (React.createElement(RadioButton, { key: idx, list: radio, name: "desk-period", onChange: function (e) {
                    setSelectedDeskTab(e.target.value);
                    if (e.target.value == "2") {
                        setShowDeskPeriodMsg(false);
                    }
                    else {
                        setShowDeskPeriodMsg(true);
                    }
                }, selected: selectedDeskTab, className: "common-radio-button  ".concat(selectedDeskTab == radio.value && "selected-desk-tab") }));
        })),
        selectedDeskTab == "1" ? (React.createElement(DeskPeriod, { isDeskOffTimeExceeded: isDeskOffTimeExceeded, className: "desk-period-box", setShowDeskPeriodPopup: props === null || props === void 0 ? void 0 : props.setShowDeskPeriodPopup, fromDate: fromDate, toDate: toDate, setFromDate: setFromDate, setToDate: setToDate })) : (React.createElement(UploadAttendance, { className: "upload-attendance", setUploadedFile: setUploadedFile })),
        React.createElement("div", { className: "".concat(selectedDeskTab == "2" ? "mx-4 mt-4" : "mx-3", " setOffDesk-buttons") },
            React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Save", disabled: (fromDate && toDate && selectedDeskTab == "1") ||
                    (selectedDeskTab == "2" && ((_a = uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.docFile) === null || _a === void 0 ? void 0 : _a.length) > 0)
                    ? false
                    : true, onClick: handleSubmit }),
            React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Cancel", onClick: function () {
                    props === null || props === void 0 ? void 0 : props.setShowDeskPeriodPopup(false);
                } }))));
};
export default SetOffDesk;
